export default __webpack_public_path__ + "static/media/Picture2.5f3afc7e.png";